import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ShaderBackground from './ShaderBackground.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GreeterPage',
  props: {
    desktopMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const source = `
// Modified From: https://www.shadertoy.com/view/WtfXRj

float rand(vec2 p) { return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453123); }

float noise(vec2 p) 
{
  vec2 i = floor(p); 
  vec2 f = fract(p);	
  vec2 u = f*f*(3.0-2.0*f);
  float a = rand(i + vec2(0, 0));
  float b = rand(i + vec2(1, 0));
  float c = rand(i + vec2(0, 1));
  float d = rand(i + vec2(1, 1));
  return float(a+(b-a)*u.x+(c-a)*u.y+(a-b-c+d)*u.x*u.y)/4.;
}

float mirror(float t, float r) 
{
  t = fract(t+r);
  return 2.*abs(t-0.5);
}

float radialNoise(float t, float d)
{
  const mat2 m2 = mat2(0.90,0.44,-0.44,0.90);
  const float SCALE = 45.;
  d = pow(d, 0.01);
  float doff = -iTime*0.07;
  vec2 p = vec2(mirror(t,0.1),d+doff);
  float f1 = noise(p * SCALE);
  p = 2.1*vec2(mirror(t,0.4),d+doff);
  float f2 = noise(p * SCALE);
  p = 3.7*vec2(mirror(t,0.8),d+doff);
  float f3 = noise(p * SCALE);
  p = 5.8*vec2(mirror(t,0.0),d+doff);
  float f4 = noise(p * SCALE);
  return pow((f1+0.5*f2+0.25*f3+0.125*f4)*3., 1.);
}

vec3 colorize(float x)
{
  x = clamp(x,0.0,1.0);
  vec3 c = mix(vec3(0,0,1.1), vec3(0,1,1), x);
  c = mix(c, vec3(1,1,1), x*4.-3.0) * x;
  c = max(c, vec3(0));
  c = mix(c, vec3(1, .25, 1), smoothstep(1.0, 0.2, x) * smoothstep(0.15, 0.9, x));
  return c;
}

//zx spectrum font
const int[] chars = int[](
    0,0,1052688,268439552,2368512,0,2391588,612246528,540200,1040858632,6448136,270943744,1058832,
    709114368,528384,0,264200,134743040,2101264,269492224,5128,1040716800,2056,1040713728,0,526352,
    0,1040187392,0,1579008,516,135274496,3950154,1382169600,1583112,134757888,3949058,1010859520,
    3949068,37895168,530472,1216219136,8274044,37895168,3948668,1111636992,8258052,135270400,3949116,
    1111636992,3949122,1040333824,16,4096,4096,1052704,1032,268960768,62,4063232,4104,67637248,3949060,
    134219776,3951190,1581267968,3949122,2118271488,8143484,1111653376,3949120,1078082560,7881794,
    1111783424,8274044,1077968384,8274044,1077952512,3949120,1312963584,4342398,1111638528,4065288,
    134757888,131586,1111636992,4474992,1212432896,4210752,1077968384,4351578,1111638528,4350546,
    1246118400,3949122,1111636992,8143426,2084585472,3949122,1380596736,8143426,2084848128,3948604,
    37895168,16650256,269488128,4342338,1111636992,4342338,1109661696,4342338,1113203712,4334616,
    405029376,8537128,269488128,8258568,270564864,919560,134745600,16416,268960768,7344144,269512704,
    1062996,269488128,0,255,1843832,539000320,14340,1011104768,2105404,572668928,7200,538975232,263228,
    1145322496,14404,2017475584,790552,269488128,15428,1144783928,4210808,1145324544,1048624,269498368,
    262148,67380248,2107440,807937024,1052688,269487104,26708,1414812672,30788,1145324544,14404,
    1145321472,30788,1148731456,15428,1144783878,7200,538976256,14400,939816960,1062928,269487104,
    17476,1145321472,17476,673714176,17492,1414801408,17448,271074304,17476,1144783928,31752,270564352,
    919600,134745600,526344,134744064,7344140,269512704,1320960,0,1010997665,2711175740
);

//i made a tool for this, https://codepen.io/ndxbxrme/pen/jOELyvd
const int[] message = int[](
  0x28,0x45,0x4c,0x4c,0x4f,0x0,0x54,0x48,0x45,0x52,0x45,0x1,0x1,0x1,0x0,0x34,0x48,0x49,0x53,0x0,0x21,0x37,
  0x25,0x33,0x2f,0x2d,0x25,0x0,0x50,0x52,0x4f,0x44,0x55,0x43,0x54,0x0,0x57,0x41,0x53,0x0,0x42,0x52,0x4f,0x55,
  0x47,0x48,0x54,0x0,0x54,0x4f,0x0,0x39,0x4f,0x55,0x0,0x42,0x59,0x0,0x54,0x48,0x49,0x53,0x0,0x23,0x2f,0x2f,0x2c,
  0x0,0x47,0x55,0x59,0x53,0x1a,0x0,0x21,0x4c,0x45,0x58,0x41,0x4e,0x44,0x45,0x52,0x0,0x34,0x41,0x52,0x41,0x53,0x4f,
  0x56,0x7,0x0,0x21,0x4e,0x41,0x54,0x4f,0x4c,0x59,0x0,0x34,0x4b,0x41,0x43,0x48,0x45,0x4e,0x4b,0x4f,0x7,0x0,0x21,
  0x4e,0x44,0x52,0x45,0x59,0x0,0x2e,0x4f,0x56,0x4f,0x53,0x45,0x4c,0x4f,0x56,0x7,0x0,0x24,0x4d,0x49,0x54,0x52,0x59,
  0x0,0x21,0x4c,0x45,0x49,0x4e,0x49,0x4b,0x4f,0x56,0x7,0x0,0x25,0x55,0x47,0x45,0x4e,0x59,0x0,0x26,0x41,0x4c,0x49,
  0x4e,0x7,0x0,0x2d,0x41,0x58,0x0,0x33,0x4d,0x49,0x52,0x4e,0x4f,0x56,0x7,0x0,0x2f,0x4c,0x47,0x41,0x0,0x33,0x48,0x41,
  0x52,0x49,0x4b,0x4f,0x56,0x41,0x7,0x0,0x30,0x45,0x54,0x45,0x52,0x0,0x22,0x45,0x53,0x50,0x41,0x4c,0x4f,0x56,0x7,
  0x0,0x36,0x4c,0x41,0x44,0x49,0x53,0x4c,0x41,0x56,0x0,0x2e,0x41,0x56,0x52,0x4f,0x43,0x4b,0x59,0x0
);
const int noChars = 226;
const float[] offsets = float[](
  0., 2., 4., 6.    
);
float pn(vec3 p) {
	//noise function by CPU https://www.shadertoy.com/view/4sfGRH
  vec3 i = vec3(.0,.0,.0);
	vec4 a = dot(i, vec3(1., 57., 21.)) + vec4(0., 57., 21., 78.);
  vec3 f = cos((p-i)*3.141592653589793)*(-.5) + .5;  
	a = mix(sin(cos(a)*a), sin(cos(1.+a)*(1.+a)), f.x);
  a.xy = mix(a.xz, a.yw, f.y);   
	return mix(a.x, a.y, f.z);
}
float printChar(vec2 uv, int charNo, int id) {
  uv.y += .5;
  uv.y -= pn(vec3(float(id) * .05 + iTime * 10.1 ));
  charNo *= 2;
  ivec2 p = ivec2(floor((uv - vec2(id * 2, 0.)) * 8.));
  if(p.x < 0 || p.x >= 8 || p.y < 0 || p.y >= 8) {
    return 0.;   
  }
  if(p.y >= 4) {
    p.y -= 4;
  }
  else
      charNo++;
  vec2 q = vec2(p);
  q -= .5;
  return float((((chars[charNo] & (0xff << (p.y * 8))) >> p.y * 8) >> (8 - p.x)) & 1) * smoothstep(0.8,0.81,length(q));
}
float printMessage(vec2 uv) {
  uv.x = mod(uv.x, float(noChars + 100));
	int id = int(floor(uv.x));
  return printChar(uv + vec2(float(id), 0.), message[id], id);
}

void mainImage(out vec4 fragColor, in vec2 fragCoord){
  vec2 uv = fragCoord;
  float d = dot(uv, uv);
  float t = atan(uv.y, uv.x) / 6.28318530718;
  float v = radialNoise(t, d);
  v = v * 2.5 - 1.4;
  v = mix(0., v, .8 * smoothstep(0.0, 0.8, d));
  fragColor.rgb = colorize(v);

  vec2 uv2 = fragCoord/iResolution.xy * vec2(3000., 2000.) + ${props.desktopMode ? '0.5' : '2.1'};
	uv2 -= .5;
	uv2.x *= iResolution.x/iResolution.y;
  vec3 col = vec3(.0, .0, .0);
  uv2.x += iTime * 2.4 + 1500.0;
  uv2 *= 8.;
	col += vec3(printMessage(uv2));
  fragColor = max(vec4(col,1.0), fragColor);
}
`

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShaderBackground, {
    source: source,
    "time-scale": 0.2
  }))
}
}

})